export * from './base-view-stock/base-view-stock.component';
